import { Table, TableBody, TableHead, TableRow, IconButton } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
} from '../../../common/components';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { formatCurrency, formatDate } from '../../../utils/formatUtils';

const PaymentsDataTable = ({ data, isLoading, onViewDetails }) => {
  return (
    <GeneralTableBox>
      <Table aria-label="payments table" stickyHeader>
        <TableHead>
          <TableRow>
            <HeadTableCell wxs="15%">Fecha Pago/Factura</HeadTableCell>
            <HeadTableCell wxs="3%">Cupones</HeadTableCell>
            <HeadTableCell wxs="15%">Entidad Rec.</HeadTableCell>
            <HeadTableCell wxs="15%">Facturas desde-hasta</HeadTableCell>
            <HeadTableCell wxs="15%">Total Cupon</HeadTableCell>
            <HeadTableCell wxs="15%">Total Facturado</HeadTableCell>
            <HeadTableCell wxs="10%">Ver</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <NoDataSkeleton colSpan={8} message="Cargando..." />
          ) : data && data.length > 0 ? (
            data.map((row, key) => (
              <TableRow key={key}>
                <RowTableCell>
                  Pago: {formatDate(row.payment_date)}
                  <br />
                  Fact.: {formatDate(row.invoice_date)}
                </RowTableCell>
                <RowTableCell>{row.coupons_count}</RowTableCell>
                <RowTableCell>{row.collector_entity}</RowTableCell>
                <RowTableCell>
                  {row.invoice_range && row.invoice_range.includes(' to ') ? (
                    <>
                      {row.invoice_range.split(' to ')[0]}
                      <br />
                      {row.invoice_range.split(' to ')[1]}
                    </>
                  ) : (
                    row.invoice_range || 'N/A'
                  )}
                </RowTableCell>
                <RowTableCell>{formatCurrency(row.total_coupon_amount)}</RowTableCell>
                <RowTableCell>{formatCurrency(row.total_invoiced_amount)}</RowTableCell>
                <RowTableCell>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() =>
                      onViewDetails(
                        row.coupons_uuids,
                        row.payment_date,
                        row.invoice_date,
                        row.collector_entity
                      )
                    }
                  >
                    <VisibilityIcon />
                  </IconButton>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={8} message="No hay registros" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default PaymentsDataTable;
